import { Component } from '@verndale/core';
import clickOutside from 'click-outside';

function scrollTo(offset, callback) {
  const fixedOffset = offset.toFixed();
  const onScroll = () => {
    if (window.pageYOffset.toFixed() === fixedOffset) {
      window.removeEventListener('scroll', onScroll);
      callback();
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
  window.scrollTo({
    top: offset,
    behavior: 'smooth'
  });
}

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $navItems: this.el._$$('.faq-content-toc__toc-anchor'),
      $sections: this.el._$$('.faq-content-toc__section'),
      $toc: this.el._$('.faq-content-toc__toc'),
      $mobileExpandTrigger: this.el._$(
        '.faq-content-toc__toc-heading-actions-wrapper'
      ),
      $mobileCollapserigger: this.el._$('.faq-content-toc__close-trigger'),
      $accordionPanels: this.el._$$('.accordion-item__panel'),
      $expandAll: parent => parent._$('.faq-content-toc__expand-all'),
      $collapseAll: parent => parent._$('.faq-content-toc__collapse-all')
    };

    this.applyMinHeightsToExpandedElements();
    this.dom.$sections.forEach(this.updateExpandButtonsDisplay.bind(this));
    this.collapsedTocClass = 'faq-content-toc__toc--mobile-collapsed';
  }

  addListeners() {
    this.dom.$navItems._on('click', this.handleNavItemsClick.bind(this));
    this.dom.$mobileExpandTrigger._on('click', this.expandToc.bind(this));
    this.dom.$mobileCollapserigger._on('click', this.collapseToc.bind(this));
    this.dom.$sections.forEach($section => {
      $section._on(
        'change',
        this.updateExpandButtonsDisplay.bind(this, $section)
      );
      this.dom
        .$expandAll($section)
        ._on('click', this.expandAll.bind(this, $section));
      this.dom
        .$collapseAll($section)
        ._on('click', this.collapseAll.bind(this, $section));
    });
    window.addEventListener('scroll', () => this.spySections());
  }

  handleNavItemsClick(e) {
    e.preventDefault();
    const $el = e.target;
    const id = $el.href.split('#')[1];
    const $target = document.getElementById(id);
    const $buttons = $target.querySelectorAll('button');
    const top = window.pageYOffset + $target.getBoundingClientRect().top;

    scrollTo(top, () => {
      for(const button of $buttons) {
        if (button.style.display !== 'none') {
          button.focus();
          break;
        }
      }
    });
  }

  updateExpandButtonsDisplay($section) {
    const allItems = $section._$$('[aria-controls]');
    const expanedItems = allItems.filter(
      item => item.getAttribute('aria-expanded') === 'true'
    );
    const $expandAll = this.dom.$expandAll($section);
    const $collapseAll = this.dom.$collapseAll($section);

    if (!expanedItems.length) {
      $expandAll.style.display = 'block';
      $collapseAll.style.display = 'none';
    } else if (expanedItems.length === allItems.length) {
      $expandAll.style.display = 'none';
      $collapseAll.style.display = 'block';
    }
  }

  expandAll($section) {
    const event = new CustomEvent('expandAll');
    $section.dispatchEvent(event);
  }

  collapseAll($section) {
    const event = new CustomEvent('collapseAll');
    $section.dispatchEvent(event);
  }

  spySections() {
    const visibilityStatus = this.dom.$sections.map(section =>
      this.determineVisibility(section)
    );

    this.updateToc(visibilityStatus);
  }

  determineVisibility(section) {
    const scrollTop = window.pageYOffset;
    const scrollBottom = scrollTop + window.innerHeight;
    const sectionTop = section.getBoundingClientRect().top + scrollTop;
    const sectionBottom = sectionTop + section.offsetHeight;

    return sectionTop < scrollBottom && sectionBottom > scrollTop;
  }

  updateToc(visibilityStatus) {
    let isAlreadyMarked = false;

    this.dom.$navItems.forEach((item, index) => {
      if (visibilityStatus[index] && !isAlreadyMarked) {
        isAlreadyMarked = true;
        item.classList.remove('link--dark');
        item.setAttribute('aria-current', 'page');
      } else {
        item.classList.add('link--dark');
        item.removeAttribute('aria-current');
      }
    });
  }

  expandToc() {
    this.dom.$toc.classList.remove(this.collapsedTocClass);
    this.unbindTocOutsideClick = clickOutside(
      this.dom.$toc,
      this.collapseToc.bind(this)
    );
  }

  collapseToc() {
    this.dom.$toc.classList.add(this.collapsedTocClass);
    this.unbindTocOutsideClick?.();
  }

  applyMinHeightsToExpandedElements() {
    const $exapnded = this.dom.$accordionPanels.filter(
      el => !el.getAttribute('aria-hidden')
    );
    $exapnded.forEach(el => {
      el.style.maxHeight = `${el.scrollHeight}px`;
    });
  }
}

export default Module;
